angular.
module("dx.webapp.time").
factory("dxTime", function timeService(
	$filter
) {
	"use strict";

	var milliSecondsInADay = 1000 * 60 * 60 * 24;

	function timeElapsed(timeStamp) {
		var delta = new Date().getTime() - new Date(timeStamp);
		var elapsedTime = $filter("date")(delta, "HH:mm:ss", "+0000");

		if (delta >= milliSecondsInADay) {
			var days = Math.floor(delta / milliSecondsInADay);
			elapsedTime = days.toString() + "d:" + elapsedTime;
		}

		return elapsedTime;
	}

	return {
		elapsed: timeElapsed,
	};
});
